module.exports = __webpack_public_path__ + "static/img/product1_1.3e1aa191.png";